<template>
  <div class="supplies-online" resmed-component-name="supplies-onliner">
    <eyebrow-icon
      v-bind:eyebrowicon="{ icon: 'shopping-cart', color: 'black' }"
      v-bind:align="'center'"
    ></eyebrow-icon>
    <h5>Want to shop for supplies online?</h5>
    <a
      v-on:click="
        $root.datalayer.push({
          event: $parent.gtm.event,
          action: 'Go to Online Dealer Locator',
          location: undefined,
        })
      "
      href="/sleep-apnea/buy-cpap-supplies-online/"
      class="btn cta-pill hallow-red icon right-arrow"
      >View online CPAP stores</a
    >
  </div>
</template>

<script>
export default {
  name: "supplies-online",
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.supplies-online {
  text-align: center;
  padding: 2rem 0;

  h5 {
    position: relative;
    margin-bottom: 1.25rem;

    @extend %eyebrow-center;
  }
}
</style>